<template>
    <div>
        <slot name="activator" v-bind:on="open"></slot>

        <b-modal ref="modal" title="การค้นหา" hide-footer>
            <form action="/tracking" method="get">
                <div class="row">
                    <div class="col-md-6 col-12">
                        <b-form-group label="จากวันที่">
                            <b-form-datepicker v-model="form.from_date"
                                               :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                                               :date-disabled-fn="shouldFromDateDisabled"></b-form-datepicker>
                        </b-form-group>
                        <input type="hidden" name="from_date" :value="form.from_date">
                    </div>
                    <div class="col-md-6 col-12">
                        <b-form-group label="ถึงวันที่">
                            <b-form-datepicker v-model="form.to_date"
                                               :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                                                :date-disabled-fn="shouldToDateDisabled"></b-form-datepicker>
                        </b-form-group>
                        <input type="hidden" name="to_date" :value="form.to_date">
                    </div>
                </div>

                <b-form-group label="สถานะจัดส่ง">
                    <b-form-select name="delivery_status" v-model="form.delivery_status" :options="statuses" />
                </b-form-group>


                <b-form-group label="คำค้นหา">
                    <b-form-input name="q" v-model="form.q" />
                </b-form-group>

                <hr>

                <div class="d-flex justify-content-between">
                    <div>
                        <b-btn v-if="hasFilter" type="button" variant="danger" href="/tracking">เริ่มใหม่</b-btn>
                    </div>
                    <div class="d-flex">
                        <b-btn type="button" variant="outline-secondary" @click.prevent="$refs.modal.hide()">ยกเลิก</b-btn>
                        <b-btn type="submit" variant="success" class="ml-2" :disabled="invalid">ค้นหา</b-btn>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>


<script>
export default {

    props: {
        filterable: {
            type: Array,
            default: []
        }
    },

    data: () => ({
        params: {},
        form: {
            q: '',
            from_date: '',
            to_date: '',
            delivery_status: '0',
        },

        statuses: {
            '0': 'ทั้งหมด',
            '103': 'รับฝาก',
            '301': 'อยู่ระหว่างการนำจ่าย',
            '401': 'นำจ่ายไม่สำเร็จ',
            '501': 'นำจ่ายสำเร็จ',
        },
    }),

    filters: {
        toText(status) {
            return this.statuses[status] || null
        }
    },

    computed: {
        invalid() {
            const allFieldsAreEmpty = Object.keys(this.form)
                .filter(key => this.form[key].length > 0)
                .length === 0

            // IF has enter date range
            // Check date should fill all fields
            if (this.form.from_date.length || this.form.to_date.length) {
                return this.form.from_date.length === 0
                    || this.form.to_date.length === 0
            }

            return allFieldsAreEmpty;
        },

        hasFilter() {
            const excepts = [
                'page'
            ];

            return Object.keys(this.form).filter((key) => {
                return !excepts.includes(key)
                    && this.form[key].length > 0
            }).length > 0
        }
    },

    methods: {
        open() {
            this.$refs.modal.show()
        },

        close() {
            this.$refs.modal.hide()
        },

        shouldFromDateDisabled(date) {
            if (this.form.to_date.length > 0) {
                return moment(date).diff(moment(this.form.to_date)) > 0
            }

            return false;
        },

        shouldToDateDisabled(date) {
            if (this.form.from_date.length > 0) {
                return moment(date).diff(moment(this.form.from_date)) < 0
            }

            return false
        }
    },

    mounted() {
        let uri = window.location.search.substring(1);
        let params = new URLSearchParams(uri);

        // Set current data from query parameter
        for (const param of params) {
            if (param.length === 2) {
                if (param[1] && param[1].length > 0) {
                    this.form[param[0]] = param[1]
                }
            }
        }
    },
}
</script>
